app.LocationList = app.AbstractCollection.extend({
  model: app.Location,

  comparator(location) {
    return `${location.get('orgNormalizedName')}/${location.get('normalizedName')}`;
  },

  url() {
    return `/api/orgs/${app.org.id}/locations`;
  },

  parse(data) {
    // Magic copy lists can include locations from other orgs of the same enterprise tag.
    this.orgNameById = data.data.orgNameById || {};
    this.crossOrgMagicCopyPermission = data.data.crossOrgMagicCopyPermission;
    return app.AbstractCollection.prototype.parse.apply(this, [data]);
  },

  /** @returns the org name when `orgId` is another org from the magic copy response, if any. */
  getOtherOrgName(orgId) {
    if (!orgId || !this.orgNameById || orgId === app.org.id) {
      return undefined;
    }
    return this.orgNameById[orgId];
  },

  getAllLiveLocations() {
    return this.models.filter((location) => {
      return location.isLive();
    });
  },

  getLocationsWithSiteId(siteId) {
    return this.models.filter((location) => {
      return location.get('siteId') === siteId;
    });
  },
});
